<template>
  <div
    class="toggle-button"
    :class="{ selected }"
    @click="$emit('toggle', !selected)"
  >
    <img v-if="selected" :src="selectedIconPath">
    <img v-else :src="unselectedIconPath">
  </div>
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    selectedIcon: {
      type: String,
      default: 'icon-selected',
    },
    unselectedIcon: {
      type: String,
      default: 'icon-unselected',
    },
  },
  computed: {
    selectedIconPath() {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      return require(`@/assets/${this.selectedIcon}.svg`);
    },
    unselectedIconPath() {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      return require(`@/assets/${this.unselectedIcon}.svg`);
    },
  },
};
</script>

<style scoped lang="scss">
.toggle-button {
  height: 24px;
  width: 24px;
  box-sizing: border-box;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
